import { searchEducations } from "@/api/education"
import { useQuery } from "@tanstack/react-query"
import { SearchEducationRequest } from "swagger/models"

const useSearchEducation = (body: SearchEducationRequest, page?: number, size?: number, sort?: Array<string>) => {
  const { data: { data: educationList } = {}, ...rest } = useQuery(
    ["educationList", page, body, sort],
    () => searchEducations(body, page, size, sort),
    {
      retry: 1,
      enabled: page !== null,
    },
  )

  return {
    educationList,
    ...rest,
  }
}

export default useSearchEducation
